module.exports = __webpack_public_path__ + "img/featured-mobile-banner.7525432a.jpg";